import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const Contact: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Helmet>
        <title>{t('metadata.contact.title')}</title>
        <meta name="description" content={t('metadata.contact.description')} />
        <link rel="canonical" href="https://iptvplayer.stream/contact" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">Contact Us</h1>
        
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6 mb-8">
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            We're here to help! If you have any questions, concerns, or feedback about IPTV Player,
            please don't hesitate to reach out to us using any of the methods below.
          </p>

          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Email Support</h2>
              <p className="text-gray-600 dark:text-gray-400">
                For general inquiries and support:
                <br />
                <a 
                  href="mailto:support@iptvplayer.stream"
                  className="text-primary hover:text-primary-dark transition-colors"
                >
                  support@mail.iptvplayer.stream
                </a>
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Response Time</h2>
              <p className="text-gray-600 dark:text-gray-400">
                We strive to respond to all inquiries within 24-48 hours during business days.
                Your feedback is important to us, and we'll do our best to address your concerns
                as quickly as possible.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}; 